// Copyright 2026. WebPros International GmbH. All rights reserved.

import { createCustomAction } from 'typesafe-actions';
import * as types from 'common/modules/root/constants/types';

export const resetState = createCustomAction(types.RESET_STATE);
